import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AssetDto } from './assets.service';

export interface AssetLinkDto {
	id: string;
	worldId: string;
	assetId: string;
	entityType: string;
	entityId: string;
	usage: string;
	sort: number;
	createdAt: string;
	updatedAt: string;
}

export interface AssetLinkWithAssetDto {
	link: AssetLinkDto;
	asset: AssetDto;
}

export interface AssetLinksListWithAssetsResponse {
	items: AssetLinkWithAssetDto[];
	total: number;
}

export interface CreateAssetLinkRequest {
	entityType: string;
	entityId: string;
	assetId: string;
	usage: string;
	sort?: number | null;
}

export interface CreateAssetLinkResponse {
	link: AssetLinkDto;
}

@Injectable({ providedIn: 'root' })
export class AssetLinksService {
	constructor(private readonly http: HttpClient) {}

	listWithAssets(
		worldId: string,
		options: {
			entityType: string;
			entityId: string;
			usage?: string | null;
			q?: string | null;
			limit?: number | null;
			offset?: number | null;
		}
	): Observable<AssetLinksListWithAssetsResponse> {
		let params = new HttpParams();
		params = params.set('entityType', options.entityType);
		params = params.set('entityId', options.entityId);
		params = params.set('includeAssets', '1');
		if (options.usage) params = params.set('usage', options.usage);
		if (options.q) params = params.set('q', options.q);
		if (options.limit != null) params = params.set('limit', String(options.limit));
		if (options.offset != null) params = params.set('offset', String(options.offset));

		return this.http.get<AssetLinksListWithAssetsResponse>(
			`${environment.api.baseUrl}/v1/worlds/${worldId}/asset-links`,
			{ params }
		);
	}

	create(worldId: string, request: CreateAssetLinkRequest): Observable<CreateAssetLinkResponse> {
		return this.http.post<CreateAssetLinkResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/asset-links`, {
			EntityType: request.entityType,
			EntityId: request.entityId,
			AssetId: request.assetId,
			Usage: request.usage,
			Sort: request.sort ?? 0,
		});
	}

	delete(worldId: string, linkId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/asset-links/${linkId}`);
	}
}
